import { render, staticRenderFns } from "./SliceAudioPlayer.vue?vue&type=template&id=1c712fcc&lang=pug&"
import script from "./SliceAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./SliceAudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./SliceAudioPlayer.vue?vue&type=style&index=0&id=1c712fcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports